import { Box, styled } from '@mui/material';

export const StyledPageContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 'calc(100vh - 64px)', // Assuming a standard app bar height of 64px
    backgroundColor: theme.palette.background.paper, // Or another suitable background for the page
}));
